import { render, staticRenderFns } from "./MarginSummary.vue?vue&type=template&id=0586db3a&scoped=true"
import script from "./MarginSummary.vue?vue&type=script&lang=js"
export * from "./MarginSummary.vue?vue&type=script&lang=js"
import style0 from "./MarginSummary.vue?vue&type=style&index=0&id=0586db3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586db3a",
  null
  
)

export default component.exports